import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import {Loader} from 'react-loaders'
import classNames from 'classnames';
import _ from 'lodash';
import L from 'leaflet';
import $ from 'jquery';
import ReactDOMServer from 'react-dom/server';

import 'leaflet.markercluster';

import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import 'leaflet.locatecontrol/dist/L.Control.Locate.min';
import 'leaflet.locatecontrol/dist/L.Control.Locate.min.css';

import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure.css';
import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure';

import './map.less';
import {connect} from "react-redux";
import MapZoomButton from "components/ui/map-zoom-button";
import * as alerts from "helpers/alerts";
import {geocode, reverseGeocode, routing, searchAddress} from "store/reducers/geo/geocoding";
import debounce from 'throttle-debounce/debounce';
import MapVehicleIcon from "components/ui/map-vehicle-icon";
import Button from "components/ui/button";
import 'leaflet-textpath';
import swal from 'sweetalert2';
import moment from "moment";
import formats from "dictionaries/formats";
import RoutingModal from "components/ui/map/controls/routing/index";
import RoutingMarker from "components/ui/map/markers/routing-marker";
import RoutingResultModal from "components/ui/map/controls/routing-result/index";
import MapGeojson from "components/ui/map/base/geojson";
import StopPointMarker from "components/ui/map/markers/stop-point-marker";
import GlobalLoaderComponent from "components/ui/global-loader";
import {formatDistance} from "helpers/functions";
import {getClosestStopPoint} from "store/reducers/routes/routes";
import MapSearch from "components/ui/map-search";
import HistoryPointMarker from "components/ui/map/markers/history-point-marker";

const payload = {
    "from": {
        "address": "\u041c\u043e\u0441\u043a\u043e\u0432\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u0441\u043a\u0438\u0439 \u0440-\u043d, \u0433. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e, \u0448. \u041c\u043e\u0436\u0430\u0439\u0441\u043a\u043e\u0435, \u0434. 136\u0410",
        "latitude": 55.684165654195,
        "longitude": 37.310256958008
    },
    "to": {
        "address": "\u041c\u043e\u0441\u043a\u043e\u0432\u0441\u043a\u0430\u044f \u043e\u0431\u043b., \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u0441\u043a\u0438\u0439 \u0440-\u043d, \u0433. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e, \u0443\u043b. \u0422\u0440\u0438\u0443\u043c\u0444\u0430\u043b\u044c\u043d\u0430\u044f, \u0434. 1\u0410",
        "latitude": 55.658221394811,
        "longitude": 37.234725952148
    },
    "items": [{
        "distance_total": 7388,
        "distance_walk": 1376,
        "time": 32,
        "departure_time": "20:46",
        "arrive_time": "21:18",
        "segments": [{
            "distance": 528,
            "time": 7,
            "mode": "walk",
            "start_at": "20:46",
            "end_at": "20:52",
            "stop_points": [{"name": "\u041e\u0442\u043f\u0440\u0430\u0432\u043d\u0430\u044f \u0442\u043e\u0447\u043a\u0430"}, {
                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
                "name": "\u041c\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
                "latitude": 55.687211,
                "longitude": 37.310902
            }],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.31016, 55.68413], [37.30975, 55.68447], [37.30943, 55.68486], [37.30919, 55.68517], [37.30888, 55.68551], [37.30812, 55.68619], [37.30811, 55.6862], [37.30811, 55.6862], [37.30811, 55.6862], [37.30802, 55.68628], [37.30775, 55.68654], [37.30769, 55.6866], [37.30805, 55.68666], [37.30862, 55.68676], [37.30964, 55.68694], [37.31014, 55.68705], [37.31067, 55.68713], [37.31088, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716]]
            }
        }, {
            "distance": 2799,
            "time": 7,
            "mode": "bus",
            "route_uuid": "a8db86fa-eb89-11e7-a2ab-439f4af8ccf7",
            "route_number": "003",
            "start_at": "20:53",
            "end_at": "21:00",
            "stop_points": [{
                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
                "name": "\u041c\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
                "latitude": 55.687211,
                "longitude": 37.310902
            }, {
                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
                "name": "\u0428\u043a\u043e\u043b\u0430 \u0418\u0441\u043a\u0443\u0441\u0441\u0442\u0432",
                "latitude": 55.685643,
                "longitude": 37.302287
            }, {
                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
                "name": "\u041d\u043e\u0432\u044b\u0435 \u0434\u043e\u043c\u0430",
                "latitude": 55.684297,
                "longitude": 37.296936
            }, {
                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
                "name": "\u0413\u0440\u0435\u0431\u043d\u0451\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.68158899,
                "longitude": 37.290746
            }, {
                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
                "name": "\u0412\u043e\u043a\u0437\u0430\u043b\u044c\u043d\u0430\u044f \u0443\u043b\u0438\u0446\u0430",
                "latitude": 55.67878299,
                "longitude": 37.283718
            }, {
                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
                "name": "\u0414\u0443\u0431\u0440\u0430\u0432\u0430",
                "latitude": 55.67685699,
                "longitude": 37.280429
            }, {
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }],
            "route_stop_points": [{
                "uuid": "849a4a32-3bee-11e8-8d7c-02faeaaa1bbe",
                "name": "\u041d\u043e\u0432\u0430\u044f \u0422\u0440\u0451\u0445\u0433\u043e\u0440\u043a\u0430",
                "latitude": 55.70419199,
                "longitude": 37.326826
            }, {
                "uuid": "704ae09a-3bea-11e8-ab47-02faeaaa1bbe",
                "name": "\u041c\u0438\u043a\u0440\u043e\u0440\u0430\u0439\u043e\u043d \u041a\u0443\u0442\u0443\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
                "latitude": 55.69578499,
                "longitude": 37.332505
            }, {
                "uuid": "6703b5b0-3bf0-11e8-bfad-02faeaaa1bbe",
                "name": "\u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0422\u0440\u0451\u0445\u0433\u043e\u0440\u043a\u0430",
                "latitude": 55.69487099,
                "longitude": 37.333876
            }, {
                "uuid": "a290721a-3bed-11e8-809e-02faeaaa1bbe",
                "name": "\u041b\u043e\u0445\u0438\u043d\u043e",
                "latitude": 55.68999399,
                "longitude": 37.322677
            }, {
                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
                "name": "\u041c\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
                "latitude": 55.68721099,
                "longitude": 37.310902
            }, {
                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
                "name": "\u0428\u043a\u043e\u043b\u0430 \u0418\u0441\u043a\u0443\u0441\u0441\u0442\u0432",
                "latitude": 55.68564299,
                "longitude": 37.302287
            }, {
                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
                "name": "\u041d\u043e\u0432\u044b\u0435 \u0434\u043e\u043c\u0430",
                "latitude": 55.684297,
                "longitude": 37.296936
            }, {
                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
                "name": "\u0413\u0440\u0435\u0431\u043d\u0451\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.68158899,
                "longitude": 37.290746
            }, {
                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
                "name": "\u0412\u043e\u043a\u0437\u0430\u043b\u044c\u043d\u0430\u044f \u0443\u043b\u0438\u0446\u0430",
                "latitude": 55.67878299,
                "longitude": 37.283718
            }, {
                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
                "name": "\u0414\u0443\u0431\u0440\u0430\u0432\u0430",
                "latitude": 55.67685699,
                "longitude": 37.280429
            }, {
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.3109, 55.68721], [37.31091, 55.68716], [37.30233, 55.68557], [37.30228, 55.68564], [37.30233, 55.68557], [37.2994, 55.68502], [37.29701, 55.68422], [37.29693, 55.68429], [37.29701, 55.68422], [37.29535, 55.68358], [37.29406, 55.68293], [37.29083, 55.68152], [37.29074, 55.68158], [37.29083, 55.68152], [37.28379, 55.67872], [37.28371, 55.67878], [37.28379, 55.67872], [37.28256, 55.67816], [37.28052, 55.67681], [37.28042, 55.67685], [37.28052, 55.67681], [37.27911, 55.67584], [37.27795, 55.67516], [37.27426, 55.67369], [37.27332, 55.67373], [37.2729, 55.67363], [37.27266, 55.67339], [37.27269, 55.67318], [37.27293, 55.67297], [37.27339, 55.67287], [37.27383, 55.67291], [37.27406, 55.67304], [37.27435, 55.67366], [37.27784, 55.67503], [37.27867, 55.67543], [37.28249, 55.67802], [37.28459, 55.67899], [37.289, 55.67609], [37.28407, 55.67373], [37.28281, 55.67349], [37.28133, 55.67276], [37.28105, 55.67274], [37.2809, 55.67204]]
            }
        }, {
            "distance": 3213,
            "time": 7,
            "mode": "bus",
            "route_uuid": "7beeecb4-eb8d-11e7-af9d-7359ef83c4de",
            "route_number": "1055",
            "start_at": "21:00",
            "end_at": "21:07",
            "stop_points": [{
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }, {
                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
                "name": "\u043a-\u0442 \u0421\u0442\u0440\u043e\u0439\u0438\u043d\u0434\u0443\u0441\u0442\u0440\u0438\u044f",
                "latitude": 55.671621,
                "longitude": 37.26823
            }, {
                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
                "name": "\u0423\u0412\u0414",
                "latitude": 55.67030699,
                "longitude": 37.263691
            }, {
                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
                "name": "\u041e\u0442\u0440\u0430\u0434\u043d\u043e\u0435",
                "latitude": 55.666001,
                "longitude": 37.249983
            }, {
                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.66356899,
                "longitude": 37.24267
            }, {
                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u043e",
                "latitude": 55.66156699,
                "longitude": 37.234113
            }],
            "route_stop_points": [{
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }, {
                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
                "name": "\u043a-\u0442 \u0421\u0442\u0440\u043e\u0439\u0438\u043d\u0434\u0443\u0441\u0442\u0440\u0438\u044f",
                "latitude": 55.671621,
                "longitude": 37.26823
            }, {
                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
                "name": "\u0423\u0412\u0414",
                "latitude": 55.67030699,
                "longitude": 37.263691
            }, {
                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
                "name": "\u041e\u0442\u0440\u0430\u0434\u043d\u043e\u0435",
                "latitude": 55.666001,
                "longitude": 37.249983
            }, {
                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.66356899,
                "longitude": 37.24267
            }, {
                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u043e",
                "latitude": 55.66156699,
                "longitude": 37.234113
            }, {
                "uuid": "906985b0-3beb-11e8-9221-02faeaaa1bbe",
                "name": "\u0414\u0443\u0431\u043a\u0438",
                "latitude": 55.661,
                "longitude": 37.2108
            }, {
                "uuid": "6dc8ad7e-3bf0-11e8-be0f-02faeaaa1bbe",
                "name": "\u042e\u0434\u0438\u043d\u043e",
                "latitude": 55.6588,
                "longitude": 37.1853
            }, {
                "uuid": "ce42d170-3bf0-11e8-af05-02faeaaa1bbe",
                "name": "\u041a\u0440\u044e\u043a\u043e\u0432\u043e",
                "latitude": 55.65623099,
                "longitude": 37.172507
            }, {
                "uuid": "54087cc8-3bed-11e8-9e34-02faeaaa1bbe",
                "name": "\u0411\u043e\u043b\u044c\u043d\u0438\u0446\u0430",
                "latitude": 55.6538,
                "longitude": 37.1562
            }, {
                "uuid": "e0f30f7c-8658-11e7-a8f8-53404d2ea619",
                "name": "\u041c\u0430\u0433\u0430\u0437\u0438\u043d",
                "latitude": 55.65459699,
                "longitude": 37.141105
            }, {
                "uuid": "41e9b474-3bef-11e8-a075-02faeaaa1bbe",
                "name": "\u0426\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.6557,
                "longitude": 37.1364
            }, {
                "uuid": "e871eb7e-8658-11e7-b334-220e952516f1",
                "name": "\u041f\u0435\u0440\u0445\u0443\u0448\u043a\u043e\u0432\u043e",
                "latitude": 55.65836899,
                "longitude": 37.126763
            }, {
                "uuid": "eeaaa1c0-3bed-11e8-8a08-02faeaaa1bbe",
                "name": "\u0414\u0430\u0447\u0438",
                "latitude": 55.6581,
                "longitude": 37.1153
            }, {
                "uuid": "e6f5dad2-3bf0-11e8-be1c-02faeaaa1bbe",
                "name": "\u0416\u0430\u0432\u043e\u0440\u043e\u043d\u043a\u0438 - 2",
                "latitude": 55.6562,
                "longitude": 37.099
            }, {
                "uuid": "e3cd06d0-8658-11e7-b07f-eda5aa455dd8",
                "name": "\u041c\u043e\u0436\u0430\u0439\u0441\u043a\u043e\u0435 \u0448\u043e\u0441\u0441\u0435",
                "latitude": 55.65207999,
                "longitude": 37.087948
            }, {
                "uuid": "520b46bc-3bf2-11e8-9f65-02faeaaa1bbe",
                "name": "\u0410\u0417\u0421",
                "latitude": 55.6474,
                "longitude": 37.0751
            }, {
                "uuid": "d966e126-3be7-11e8-ab77-02faeaaa1bbe",
                "name": "\u041c\u0430\u043b\u044b\u0435 \u0412\u044f\u0437\u0451\u043c\u044b",
                "latitude": 55.6337,
                "longitude": 37.0353
            }, {
                "uuid": "fd7c2994-8658-11e7-aac9-53f36665a911",
                "name": "\u0424\u0430\u0431\u0440\u0438\u043a\u0430",
                "latitude": 55.62986699,
                "longitude": 37.019303
            }, {
                "uuid": "43416950-3bec-11e8-a307-02faeaaa1bbe",
                "name": "\u0413\u043e\u043b\u0410\u0417",
                "latitude": 55.6299,
                "longitude": 37.0109
            }, {
                "uuid": "2bc6a828-3bea-11e8-936a-02faeaaa1bbe",
                "name": "\u041f\u043e\u0441\u0451\u043b\u043e\u043a \u0428\u043a\u043e\u043b\u044c\u043d\u044b\u0439",
                "latitude": 55.63,
                "longitude": 37.0042
            }, {
                "uuid": "dad8ee36-8658-11e7-8b14-007cfa75f777",
                "name": "\u0418\u043d\u0441\u0442\u0438\u0442\u0443\u0442",
                "latitude": 55.62993599,
                "longitude": 36.996558
            }, {
                "uuid": "9ff4629a-3bee-11e8-abaf-02faeaaa1bbe",
                "name": "\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u0412\u044f\u0437\u0451\u043c\u044b",
                "latitude": 55.629522316794,
                "longitude": 36.985355615616
            }, {
                "uuid": "b999cb88-3be7-11e8-95e9-02faeaaa1bbe",
                "name": "\u0414\u0435\u0432\u044f\u0442\u043a\u0438",
                "latitude": 55.6205,
                "longitude": 36.9848
            }, {
                "uuid": "4561fe66-865c-11e7-bc80-be4b3dc833bf",
                "name": "\u0421\u0442.\u0413\u043e\u043b\u0438\u0446\u044b\u043d\u043e",
                "latitude": 55.616398861671,
                "longitude": 36.988785842394
            }],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.2809, 55.67204], [37.28105, 55.67274], [37.27963, 55.67369], [37.27775, 55.67509], [37.27252, 55.67294], [37.26827, 55.67156], [37.26823, 55.67162], [37.26827, 55.67156], [37.26379, 55.67019], [37.26369, 55.6703], [37.26379, 55.67019], [37.2585, 55.6687], [37.25007, 55.66591], [37.24998, 55.666], [37.25007, 55.66591], [37.24275, 55.66347], [37.24266, 55.66356], [37.24275, 55.66347], [37.23893, 55.66229], [37.23416, 55.66147], [37.23411, 55.66156]]
            }
        }, {
            "distance": 848,
            "time": 11,
            "mode": "walk",
            "start_at": "21:07",
            "end_at": "21:18",
            "stop_points": [{
                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u043e",
                "latitude": 55.66156699,
                "longitude": 37.234113
            }, {"name": "\u041a\u043e\u043d\u0435\u0447\u043d\u044b\u0439 \u043f\u0443\u043d\u043a\u0442"}],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.23416, 55.66147], [37.23489, 55.66159], [37.23489, 55.66159], [37.23523, 55.66165], [37.23756, 55.66204], [37.23807, 55.66123], [37.23809, 55.66109], [37.23813, 55.66081], [37.23815, 55.66051], [37.23813, 55.66036], [37.23783, 55.65959], [37.23628, 55.65943], [37.2361, 55.6594], [37.23603, 55.65936], [37.23598, 55.6593], [37.23596, 55.65921], [37.236, 55.65885], [37.236, 55.65883], [37.236, 55.65883], [37.23604, 55.65844], [37.23607, 55.65805], [37.23539, 55.65803], [37.23475, 55.658]]
            }
        }]
    }, {
        "distance_total": 7388,
        "distance_walk": 1376,
        "time": 43,
        "departure_time": "21:15",
        "arrive_time": "21:58",
        "segments": [{
            "distance": 528,
            "time": 7,
            "mode": "walk",
            "start_at": "21:15",
            "end_at": "21:21",
            "stop_points": [{"name": "\u041e\u0442\u043f\u0440\u0430\u0432\u043d\u0430\u044f \u0442\u043e\u0447\u043a\u0430"}, {
                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
                "name": "\u041c\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
                "latitude": 55.687211,
                "longitude": 37.310902
            }],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.31016, 55.68413], [37.30975, 55.68447], [37.30943, 55.68486], [37.30919, 55.68517], [37.30888, 55.68551], [37.30812, 55.68619], [37.30811, 55.6862], [37.30811, 55.6862], [37.30811, 55.6862], [37.30802, 55.68628], [37.30775, 55.68654], [37.30769, 55.6866], [37.30805, 55.68666], [37.30862, 55.68676], [37.30964, 55.68694], [37.31014, 55.68705], [37.31067, 55.68713], [37.31088, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716], [37.31091, 55.68716]]
            }
        }, {
            "distance": 2799,
            "time": 11,
            "mode": "bus",
            "route_uuid": "a8db86fa-eb89-11e7-a2ab-439f4af8ccf7",
            "route_number": "003",
            "start_at": "21:22",
            "end_at": "21:33",
            "stop_points": [{
                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
                "name": "\u041c\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
                "latitude": 55.687211,
                "longitude": 37.310902
            }, {
                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
                "name": "\u0428\u043a\u043e\u043b\u0430 \u0418\u0441\u043a\u0443\u0441\u0441\u0442\u0432",
                "latitude": 55.685643,
                "longitude": 37.302287
            }, {
                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
                "name": "\u041d\u043e\u0432\u044b\u0435 \u0434\u043e\u043c\u0430",
                "latitude": 55.684297,
                "longitude": 37.296936
            }, {
                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
                "name": "\u0413\u0440\u0435\u0431\u043d\u0451\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.68158899,
                "longitude": 37.290746
            }, {
                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
                "name": "\u0412\u043e\u043a\u0437\u0430\u043b\u044c\u043d\u0430\u044f \u0443\u043b\u0438\u0446\u0430",
                "latitude": 55.67878299,
                "longitude": 37.283718
            }, {
                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
                "name": "\u0414\u0443\u0431\u0440\u0430\u0432\u0430",
                "latitude": 55.67685699,
                "longitude": 37.280429
            }, {
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }],
            "route_stop_points": [{
                "uuid": "f2e7f80e-3bee-11e8-be46-02faeaaa1bbe",
                "name": "\u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0422\u0440\u0451\u0445\u0433\u043e\u0440\u043a\u0430",
                "latitude": 55.69487199,
                "longitude": 37.334856
            }, {
                "uuid": "6703b5b0-3bf0-11e8-bfad-02faeaaa1bbe",
                "name": "\u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0422\u0440\u0451\u0445\u0433\u043e\u0440\u043a\u0430",
                "latitude": 55.69487099,
                "longitude": 37.333876
            }, {
                "uuid": "a290721a-3bed-11e8-809e-02faeaaa1bbe",
                "name": "\u041b\u043e\u0445\u0438\u043d\u043e",
                "latitude": 55.68999399,
                "longitude": 37.322677
            }, {
                "uuid": "1253b86c-3beb-11e8-83cf-02faeaaa1bbe",
                "name": "\u041c\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
                "latitude": 55.68721099,
                "longitude": 37.310902
            }, {
                "uuid": "345afa34-3bef-11e8-8e56-02faeaaa1bbe",
                "name": "\u0428\u043a\u043e\u043b\u0430 \u0418\u0441\u043a\u0443\u0441\u0441\u0442\u0432",
                "latitude": 55.68564299,
                "longitude": 37.302287
            }, {
                "uuid": "0b36da78-3bf0-11e8-90ef-02faeaaa1bbe",
                "name": "\u041d\u043e\u0432\u044b\u0435 \u0434\u043e\u043c\u0430",
                "latitude": 55.684297,
                "longitude": 37.296936
            }, {
                "uuid": "d1981a56-3bf0-11e8-9e97-02faeaaa1bbe",
                "name": "\u0413\u0440\u0435\u0431\u043d\u0451\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.68158899,
                "longitude": 37.290746
            }, {
                "uuid": "ed0688b6-3bed-11e8-9336-02faeaaa1bbe",
                "name": "\u0412\u043e\u043a\u0437\u0430\u043b\u044c\u043d\u0430\u044f \u0443\u043b\u0438\u0446\u0430",
                "latitude": 55.67878299,
                "longitude": 37.283718
            }, {
                "uuid": "ae86edee-3be6-11e8-a020-02faeaaa1bbe",
                "name": "\u0414\u0443\u0431\u0440\u0430\u0432\u0430",
                "latitude": 55.67685699,
                "longitude": 37.280429
            }, {
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.3109, 55.68721], [37.31091, 55.68716], [37.30233, 55.68557], [37.30228, 55.68564], [37.30233, 55.68557], [37.2994, 55.68502], [37.29701, 55.68422], [37.29693, 55.68429], [37.29701, 55.68422], [37.29535, 55.68358], [37.29406, 55.68293], [37.29083, 55.68152], [37.29074, 55.68158], [37.29083, 55.68152], [37.28379, 55.67872], [37.28371, 55.67878], [37.28379, 55.67872], [37.28256, 55.67816], [37.28052, 55.67681], [37.28042, 55.67685], [37.28052, 55.67681], [37.27911, 55.67584], [37.27795, 55.67516], [37.27426, 55.67369], [37.27332, 55.67373], [37.2729, 55.67363], [37.27266, 55.67339], [37.27269, 55.67318], [37.27293, 55.67297], [37.27339, 55.67287], [37.27383, 55.67291], [37.27406, 55.67304], [37.27435, 55.67366], [37.27784, 55.67503], [37.27867, 55.67543], [37.28249, 55.67802], [37.28459, 55.67899], [37.289, 55.67609], [37.28407, 55.67373], [37.28281, 55.67349], [37.28133, 55.67276], [37.28105, 55.67274], [37.2809, 55.67204]]
            }
        }, {
            "distance": 3213,
            "time": 7,
            "mode": "bus",
            "route_uuid": "7beeecb4-eb8d-11e7-af9d-7359ef83c4de",
            "route_number": "1055",
            "start_at": "21:40",
            "end_at": "21:47",
            "stop_points": [{
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }, {
                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
                "name": "\u043a-\u0442 \u0421\u0442\u0440\u043e\u0439\u0438\u043d\u0434\u0443\u0441\u0442\u0440\u0438\u044f",
                "latitude": 55.671621,
                "longitude": 37.26823
            }, {
                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
                "name": "\u0423\u0412\u0414",
                "latitude": 55.67030699,
                "longitude": 37.263691
            }, {
                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
                "name": "\u041e\u0442\u0440\u0430\u0434\u043d\u043e\u0435",
                "latitude": 55.666001,
                "longitude": 37.249983
            }, {
                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.66356899,
                "longitude": 37.24267
            }, {
                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u043e",
                "latitude": 55.66156699,
                "longitude": 37.234113
            }],
            "route_stop_points": [{
                "uuid": "13492c80-3bea-11e8-952c-02faeaaa1bbe",
                "name": "\u0441\u0442. \u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043e",
                "latitude": 55.6720448283,
                "longitude": 37.28090270056
            }, {
                "uuid": "b456e144-3bef-11e8-aba3-02faeaaa1bbe",
                "name": "\u043a-\u0442 \u0421\u0442\u0440\u043e\u0439\u0438\u043d\u0434\u0443\u0441\u0442\u0440\u0438\u044f",
                "latitude": 55.671621,
                "longitude": 37.26823
            }, {
                "uuid": "91cb95d6-3bed-11e8-8737-02faeaaa1bbe",
                "name": "\u0423\u0412\u0414",
                "latitude": 55.67030699,
                "longitude": 37.263691
            }, {
                "uuid": "6b4ff982-3bee-11e8-a5a2-02faeaaa1bbe",
                "name": "\u041e\u0442\u0440\u0430\u0434\u043d\u043e\u0435",
                "latitude": 55.666001,
                "longitude": 37.249983
            }, {
                "uuid": "2ff023be-3bec-11e8-b18f-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u0441\u043a\u0430\u044f \u0446\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.66356899,
                "longitude": 37.24267
            }, {
                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u043e",
                "latitude": 55.66156699,
                "longitude": 37.234113
            }, {
                "uuid": "906985b0-3beb-11e8-9221-02faeaaa1bbe",
                "name": "\u0414\u0443\u0431\u043a\u0438",
                "latitude": 55.661,
                "longitude": 37.2108
            }, {
                "uuid": "6dc8ad7e-3bf0-11e8-be0f-02faeaaa1bbe",
                "name": "\u042e\u0434\u0438\u043d\u043e",
                "latitude": 55.6588,
                "longitude": 37.1853
            }, {
                "uuid": "ce42d170-3bf0-11e8-af05-02faeaaa1bbe",
                "name": "\u041a\u0440\u044e\u043a\u043e\u0432\u043e",
                "latitude": 55.65623099,
                "longitude": 37.172507
            }, {
                "uuid": "54087cc8-3bed-11e8-9e34-02faeaaa1bbe",
                "name": "\u0411\u043e\u043b\u044c\u043d\u0438\u0446\u0430",
                "latitude": 55.6538,
                "longitude": 37.1562
            }, {
                "uuid": "e0f30f7c-8658-11e7-a8f8-53404d2ea619",
                "name": "\u041c\u0430\u0433\u0430\u0437\u0438\u043d",
                "latitude": 55.65459699,
                "longitude": 37.141105
            }, {
                "uuid": "41e9b474-3bef-11e8-a075-02faeaaa1bbe",
                "name": "\u0426\u0435\u0440\u043a\u043e\u0432\u044c",
                "latitude": 55.6557,
                "longitude": 37.1364
            }, {
                "uuid": "e871eb7e-8658-11e7-b334-220e952516f1",
                "name": "\u041f\u0435\u0440\u0445\u0443\u0448\u043a\u043e\u0432\u043e",
                "latitude": 55.65836899,
                "longitude": 37.126763
            }, {
                "uuid": "eeaaa1c0-3bed-11e8-8a08-02faeaaa1bbe",
                "name": "\u0414\u0430\u0447\u0438",
                "latitude": 55.6581,
                "longitude": 37.1153
            }, {
                "uuid": "e6f5dad2-3bf0-11e8-be1c-02faeaaa1bbe",
                "name": "\u0416\u0430\u0432\u043e\u0440\u043e\u043d\u043a\u0438 - 2",
                "latitude": 55.6562,
                "longitude": 37.099
            }, {
                "uuid": "e3cd06d0-8658-11e7-b07f-eda5aa455dd8",
                "name": "\u041c\u043e\u0436\u0430\u0439\u0441\u043a\u043e\u0435 \u0448\u043e\u0441\u0441\u0435",
                "latitude": 55.65207999,
                "longitude": 37.087948
            }, {
                "uuid": "520b46bc-3bf2-11e8-9f65-02faeaaa1bbe",
                "name": "\u0410\u0417\u0421",
                "latitude": 55.6474,
                "longitude": 37.0751
            }, {
                "uuid": "d966e126-3be7-11e8-ab77-02faeaaa1bbe",
                "name": "\u041c\u0430\u043b\u044b\u0435 \u0412\u044f\u0437\u0451\u043c\u044b",
                "latitude": 55.6337,
                "longitude": 37.0353
            }, {
                "uuid": "fd7c2994-8658-11e7-aac9-53f36665a911",
                "name": "\u0424\u0430\u0431\u0440\u0438\u043a\u0430",
                "latitude": 55.62986699,
                "longitude": 37.019303
            }, {
                "uuid": "43416950-3bec-11e8-a307-02faeaaa1bbe",
                "name": "\u0413\u043e\u043b\u0410\u0417",
                "latitude": 55.6299,
                "longitude": 37.0109
            }, {
                "uuid": "2bc6a828-3bea-11e8-936a-02faeaaa1bbe",
                "name": "\u041f\u043e\u0441\u0451\u043b\u043e\u043a \u0428\u043a\u043e\u043b\u044c\u043d\u044b\u0439",
                "latitude": 55.63,
                "longitude": 37.0042
            }, {
                "uuid": "dad8ee36-8658-11e7-8b14-007cfa75f777",
                "name": "\u0418\u043d\u0441\u0442\u0438\u0442\u0443\u0442",
                "latitude": 55.62993599,
                "longitude": 36.996558
            }, {
                "uuid": "9ff4629a-3bee-11e8-abaf-02faeaaa1bbe",
                "name": "\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u0412\u044f\u0437\u0451\u043c\u044b",
                "latitude": 55.629522316794,
                "longitude": 36.985355615616
            }, {
                "uuid": "b999cb88-3be7-11e8-95e9-02faeaaa1bbe",
                "name": "\u0414\u0435\u0432\u044f\u0442\u043a\u0438",
                "latitude": 55.6205,
                "longitude": 36.9848
            }, {
                "uuid": "4561fe66-865c-11e7-bc80-be4b3dc833bf",
                "name": "\u0421\u0442.\u0413\u043e\u043b\u0438\u0446\u044b\u043d\u043e",
                "latitude": 55.616398861671,
                "longitude": 36.988785842394
            }],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.2809, 55.67204], [37.28105, 55.67274], [37.27963, 55.67369], [37.27775, 55.67509], [37.27252, 55.67294], [37.26827, 55.67156], [37.26823, 55.67162], [37.26827, 55.67156], [37.26379, 55.67019], [37.26369, 55.6703], [37.26379, 55.67019], [37.2585, 55.6687], [37.25007, 55.66591], [37.24998, 55.666], [37.25007, 55.66591], [37.24275, 55.66347], [37.24266, 55.66356], [37.24275, 55.66347], [37.23893, 55.66229], [37.23416, 55.66147], [37.23411, 55.66156]]
            }
        }, {
            "distance": 848,
            "time": 11,
            "mode": "walk",
            "start_at": "21:47",
            "end_at": "21:58",
            "stop_points": [{
                "uuid": "bf8993fa-3be9-11e8-8437-02faeaaa1bbe",
                "name": "\u0410\u043a\u0443\u043b\u043e\u0432\u043e",
                "latitude": 55.66156699,
                "longitude": 37.234113
            }, {"name": "\u041a\u043e\u043d\u0435\u0447\u043d\u044b\u0439 \u043f\u0443\u043d\u043a\u0442"}],
            "geometry": {
                "type": "LineString",
                "coordinates": [[37.23416, 55.66147], [37.23489, 55.66159], [37.23489, 55.66159], [37.23523, 55.66165], [37.23756, 55.66204], [37.23807, 55.66123], [37.23809, 55.66109], [37.23813, 55.66081], [37.23815, 55.66051], [37.23813, 55.66036], [37.23783, 55.65959], [37.23628, 55.65943], [37.2361, 55.6594], [37.23603, 55.65936], [37.23598, 55.6593], [37.23596, 55.65921], [37.236, 55.65885], [37.236, 55.65883], [37.236, 55.65883], [37.23604, 55.65844], [37.23607, 55.65805], [37.23539, 55.65803], [37.23475, 55.658]]
            }
        }]
    }]
};

@propTypes({
    showLayers: PropTypes.bool,
    withRouting: PropTypes.bool,
    showSearch: PropTypes.bool,
    layers: PropTypes.array,
    onZoom: PropTypes.func,
})

@defaultProps({
    showLayers: true,
    withRouting: false,
    showSearch: true,
    layers: [],
    onZoom: () => {
    },
})

@connect(state => ({}), {geocode, reverseGeocode, searchAddress, routing, getClosestStopPoint}, null, {withRef: true})

export default class MapComponent extends Component {

    defaultRouting = {
        date: moment(),
        time: moment().format(formats.TIME),
        max_time: '04:00',
        max_transfers: 2,
        walk_reluctance: 2,
        is_wheelchair: false,
        mode_bus: true,
        mode_tram: true,
        mode_train: true,
        mode_subway: true,
        from: {
            latitude: null,
            longitude: null,
            address: '',
        },
        to: {
            latitude: null,
            longitude: null,
            address: '',
        },
        transit: [],
    };


    geocodeDebounce = debounce(500, ::this.geocode);
    suggestAddressDebounce = debounce(500, ::this.suggestAddress);

    state = {
        loading: false,
        routingActive: false,
        routingResultActive: false,
        routing: _.cloneDeep(this.defaultRouting),
        routingResult: null,
        activeRoutingResultItem: 0,
        activeSegment: null,
        activeSearchMarker: null,
        searchStopPoints: [],
    };

    map = null;
    objectsLayer = null;
    mapSearchObjectsLayer = null;
    locateBtn = null;
    measureBtn = null;

    tilePath(tile) {
        return window.RNIS_SETTINGS.OSMDEFAULTLAYER ? `${tile.s}.tile.openstreetmap.org/${tile.z}/${tile.x}/${tile.y}.png` :
            (tile.z + '00' + (1000000000 + tile.x).toString().substr(1)
                + (1000000000 + tile.y).toString().substr(1)).replace(/^(\d{1,2})00(\d{3})(\d{3})(\d{3})(\d{3})(\d{3})(\d{3})/, '$1/00/$2/$3/$4/$5/$6/$7');
    }

    // тайлы новосибирска
    arcgisTilePath(tile) {
        return `maps.nso.ru/arcgis3/rest/services/Common/BASEMAP_BIPD/MapServer/tile/${tile.z}/${tile.y}/${tile.x}`
    }

    componentDidMount() {
        this.init();

        setTimeout(() => {
            this.map.invalidateSize();
        }, 500);

        setTimeout(() => {
            this.map.invalidateSize();
        }, 1500);
    }

    isMosreg() {
        return (/\.mosreg.ru$/.test(window.location.hostname));
    }

    isNso() {
        return (/\.nso.ru$/.test(window.location.hostname));
    }

    isLocalhost() {
        return (/localhost$/.test(window.location.hostname));
    }

    init() {
        let osmDelault = window.RNIS_SETTINGS.OSMDEFAULTLAYER !== undefined ? window.RNIS_SETTINGS.OSMDEFAULTLAYER : false;
        //const osmUrl = (/\.mosreg.ru$/.test(window.location.hostname)) ? '//portal.rnis.mosreg.ru/g-map/lv{path}.png' : 'http://95.181.199.194/g-map/lv{path}.png';
        const osmUrl = osmDelault ? 'http://{path}' : `${window.location.protocol}//portal.rnis.mosreg.ru/g-map/lv{path}.png`;

        this.osmLayer = new L.TileLayer(osmUrl, {
            path: this.tilePath,
            maxZoom: 19,
            minZoom: 3,
            tms: !window.RNIS_SETTINGS.OSMDEFAULTLAYER,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });

        this.arcgisLayer = new L.TileLayer(osmUrl, {
            path: this.arcgisTilePath,
            maxZoom: 19,
            minZoom: 3,
            tms: !window.RNIS_SETTINGS.OSMDEFAULTLAYER,
        });


        /* const osmLayer = new L.TileLayer(osmUrl, {
             path: this.tilePath,
             maxZoom: 19,
             minZoom: 3,
             tms: !window.RNIS_SETTINGS.OSMDEFAULTLAYER
         });*/

        L.Icon.Default.imagePath = '/static/img/vendor/leaflet/';
        let center;
        let zoom;
        if (window.RNIS_SETTINGS.CITY_MURMANSK) {
            center = new L.LatLng(68.9629, 33.0831);
            zoom = 5;
        } else {
            zoom = 11;
            if (window.RNIS_SETTINGS.MAPCENTER) {
                center = new L.LatLng(window.RNIS_SETTINGS.MAPCENTER.LAT, window.RNIS_SETTINGS.MAPCENTER.LON);
            } else {
                center = new L.LatLng(55.753559, 37.609218);
            }
        }

        this.map = new L.map(this.refs.container, {
            center:  center,
            //path: this.tilePath,
            zoom: zoom,
            maxZoom: 17,
            minZoom: 3,
            preferCanvas: false,
            layers: this.isNso() ? [
                this.arcgisLayer,
                //this.osmLayer,
            ] : [
                this.osmLayer,
            ],
            zoomControl: false
        });

        if (this.isNso()) {
            let layers = {
                'РГИС НСО': this.arcgisLayer,
                'OpenStreetMap': this.osmLayer
            };

            !this.isNso() && delete layers['РГИС НСО'];

            L.control.layers(layers).addTo(this.map);
        }

        this.locateBtn = L.control.locate({
            position: 'topright',
            onLocationError: (err) => {
                alerts.error('Ошибка определения местоположения.');
            },
            showPopup: false,
            strings: {
                title: 'Определить местоположение',
            },
        });
        this.locateBtn.addTo(this.map);

        this.map.on('click', ::this.onMapClick);
        this.map.on('mousemove', ::this.onMapMouseMove);

        this.measureBtn = L.control.polylineMeasure();
        this.measureBtn.addTo(this.map);

        this.map.on('moveend', ::this.onZoom);
        this.map.on('zoomend', ::this.onZoomChange);

        this.objectsLayer = new L.layerGroup().addTo(this.map);
        this.mapSearchObjectsLayer = new L.layerGroup().addTo(this.map);

        this.setState({map: this.map});
    }

    getBoundingBox() {
        const map = this.map;

        const bounds = map.getBounds();

        if (window.RNIS_SETTINGS.CITY_MURMANSK) {
            const latlngs = [[ 70.8806, 27.6681 ], [ 65.6981, 29.4259 ], [ 65.8245, 44.1036 ], [ 70.9812, 40.0607 ], [ 70.8806, 27.6681 ]];
            const polygon = L.polygon(latlngs, {});
            if (!polygon.getBounds().contains(bounds)) {
                return {
                    left_top: {
                        latitude: 69.94537515,
                        longitude: 27.90527344
                    },
                    right_bottom: {
                        latitude: 65.73062649,
                        longitude: 41.69311523
                    }
                }
            } else {
                return {
                    left_top: {
                        latitude: bounds.getNorth(),
                        longitude: bounds.getEast(),
                    },
                    right_bottom: {
                        latitude: bounds.getSouth(),
                        longitude: bounds.getWest(),
                    },
                };
            }
        }

        return {
            left_top: {
                latitude: bounds.getNorth(),
                longitude: bounds.getEast(),
            },
            right_bottom: {
                latitude: bounds.getSouth(),
                longitude: bounds.getWest(),
            },
        };
    }

    getMapSize() {
        const map = this.map;

        const size = map.getSize();
        return {
            width: size.x,
            height: size.y,
        };
    }

    getZoom() {
        return this.map.getZoom();
    }

    onZoom() {
        this.props.onZoom();
    }

    onZoomChange(e) {
        this.forceUpdate();
    }

    componentWillUpdate(props, state) {
        this.renderUserGeoObjects(props.userGeoObjects);
        this.renderMapSearchObjects(props.mapSearchObjects);
    }

    render() {
        const mapSearch = (this.map && !window.RNIS_SETTINGS.CITY_MURMANSK) ? (
            <MapSearch onClick={::this.onSuggestClick} map={this.map} zoom={this.getZoom()}
                       setSearchStopPoints={::this.setSearchStopPoints}/>) : null;
        const mapZoomControls = this.map ? (
            <div className={classNames('leaflet-map-zoom-buttons', {
                'routing-active': this.state.routingActive,
                'routing-result-active': this.state.routingResultActive,
            })}>
                <MapZoomButton type="in" onClick={::this.zoomIn}/>
                <MapZoomButton type="out" onClick={::this.zoomOut}/>
                {!window.RNIS_SETTINGS.CITY_MURMANSK ? <MapZoomButton type="locate" onClick={::this.locate} tooltip="Моё местоположение"/> : null}
                {!location.pathname.includes('map/road') && <MapZoomButton type="measure" onClick={::this.measure} tooltip="Линейка"/>}
                {this.props.withRouting ? (
                    <MapZoomButton type="routing" onClick={::this.routing} tooltip="Построить маршрут"/>
                ) : null}
            </div>
        ) : null;
        const routingControls = (this.state.routingActive && !this.state.routingResultActive) ? (
            <RoutingModal
                ref="routing"
                onClose={::this.closeRouting}
                data={this.state.routing}
                onChange={::this.onRoutingChange}
                routingFocus={::this.routingFocus}
                startRouting={::this.startRouting}
                suggestAddress={::this.suggestAddress}
            />
        ) : null;
        const routingResultControls = (this.state.routingActive && this.state.routingResultActive) ? (
            <RoutingResultModal
                ref="routing-results"
                onClose={::this.closeRouting}
                data={this.state.routingResult}
                onRoutingConfigure={::this.onRoutingConfigure}
                onRoutingReset={::this.onRoutingReset}
                activeRoutingResultItem={this.state.activeRoutingResultItem}
                setActiveRoutingResultItem={::this.setActiveRoutingResultItem}
                activeSegment={this.state.activeSegment}
                setActiveSegment={::this.setActiveSegment}
            />
        ) : null;

        return (
            <div className={classNames('leaflet-map', this.map ? `zoom-${this.map.getZoom()}` : '', {
                'routing-result-active': this.state.routingResultActive,
            })}>
                {this.state.loading ? <GlobalLoaderComponent/> : null}
                {mapSearch}
                {mapZoomControls}
                {routingControls}
                {routingResultControls}
                <div className="map-container" ref="container"/>
                <div style={{display: 'none'}}>
                    {this.renderRoutingRequestMarkers()}
                    {this.renderRoutingResult()}
                    {this.props.children}
                    {this.renderActiveSearch()}
                    {this.renderSearchStopPoints()}
                </div>
            </div>
        );
    }

    setActiveRoutingResultItem(index) {
        if (index < 0) {
            index = this.state.routingResult.items.length - 1;
        }
        if (index >= this.state.routingResult.items.length) {
            index = 0;
        }
        this.setState({
            activeRoutingResultItem: index,
        });
    }

    async suggestAddress(input, callback) {
        if (!input) {
            callback(null, {
                options: [],
                complete: false,
            });
            return;
        }

        const bounds = this.map.getBounds();
        const boundingBox = {
            left: bounds.getNorth(),
            top: bounds.getEast(),
            right: bounds.getSouth(),
            bottom: bounds.getWest(),
        };

        const response = await this.props.searchAddress(input, boundingBox, this.getZoom());

        if (response.isOk) {
            callback(null, {
                options: _.sortBy(_.map(response.payload.items, (item) => ({
                    value: item.name,
                    label: item.name,
                    latitude: item.coordinates.latitude,
                    longitude: item.coordinates.longitude,
                    address: item.address,
                })), 'label'),
                complete: false,
            });
        } else {
            response.showErrors();
        }
    }

    onRoutingConfigure() {
        this.setState({
            routingResultActive: false,
        });
    }

    onRoutingReset() {
        this.setState({
            routingResultActive: false,
            routing: _.cloneDeep(this.defaultRouting),
        });
    }

    async onRoutingChange(field, value, ignore = false) {
        if (field === 'max_transfers') {
            value = _.toInteger(value);
        }

        let routing = this.state.routing;
        _.set(routing, field, value);
        await this.setState({routing});

        if (ignore) {
            return;
        }

        const addressMatches = /^(.+)\.address$/.exec(field);
        if (addressMatches) {
            this.geocodeDebounce(addressMatches[1]);
        }
    }

    async geocode(focusRoute) {
        const bounds = this.map.getBounds();

        const boundingBox = {
            left: bounds.getNorth(),
            top: bounds.getEast(),
            right: bounds.getSouth(),
            bottom: bounds.getWest(),
        };
        const response = await this.props.geocode(_.get(this.state.routing, `${focusRoute}.address`), boundingBox, this.getZoom());
        if (response.isOk) {
            this.onRoutingChange(`${focusRoute}.latitude`, response.payload.coordinates.latitude);
            this.onRoutingChange(`${focusRoute}.longitude`, response.payload.coordinates.longitude);
        }
    }

    routingFocus(focusRoute, lat, lon) {
        this.setState({focusRoute});
        if (lat && lat) {
            this.reverseGeocode(lat, lon, 'from');
        }
    }

    // handleClearRoutingFocus = () => {
    //     this.setState({focusRoute: null});
    // }

    onMapClick(e) {
        if (!this.state.routingActive || !this.state.focusRoute) {
            return;
        }
        if (/transit/.test(this.state.focusRoute)) {
            this.findClosestStopPoint(e.latlng.lat, e.latlng.lng);
            return;
        }

        this.reverseGeocode(e.latlng.lat, e.latlng.lng, this.state.focusRoute);
        this.setState({
            focusRoute: null,
        });
    }

    async findClosestStopPoint(latitude, longitude) {
        const response = await this.props.getClosestStopPoint(latitude, longitude);

        if (response.isOk) {
            const stopPoint = response.payload;

            this.onRoutingChange(`${this.state.focusRoute}.address`, stopPoint.title, true);
            this.onRoutingChange(`${this.state.focusRoute}.latitude`, stopPoint.latitude);
            this.onRoutingChange(`${this.state.focusRoute}.longitude`, stopPoint.longitude);

            this.setState({
                focusRoute: null,
            });
        } else {
            response.showErrors();
        }
    }

    async onStopPointClick(stopPoint) {
        this.onRoutingChange(`${this.state.focusRoute}.address`, stopPoint.title, true);
        this.onRoutingChange(`${this.state.focusRoute}.latitude`, stopPoint.latitude);
        this.onRoutingChange(`${this.state.focusRoute}.longitude`, stopPoint.longitude);

        this.setState({
            focusRoute: null,
        });
    }

    onMapMouseMove(e) {
        if (!this.state.routingActive || !this.state.focusRoute) {
            return;
        }

        this.onRoutingChange(`${this.state.focusRoute}.latitude`, e.latlng.lat);
        this.onRoutingChange(`${this.state.focusRoute}.longitude`, e.latlng.lng);
    }

    onMarkerDragEnd(focusRoute, {target}) {
        const {lat, lng} = target.getLatLng();
        this.onRoutingChange(`${focusRoute}.latitude`, lat);
        this.onRoutingChange(`${focusRoute}.longitude`, lng);
        this.reverseGeocode(lat, lng, focusRoute);
    }

    async reverseGeocode(latitude, longitude, focusRoute) {
        this.onRoutingChange(`${focusRoute}.latitude`, latitude);
        this.onRoutingChange(`${focusRoute}.longitude`, longitude);

        const bounds = this.map.getBounds();

        const boundingBox = {
            left: bounds.getNorth(),
            top: bounds.getEast(),
            right: bounds.getSouth(),
            bottom: bounds.getWest(),
        };
        const response = await this.props.reverseGeocode({latitude, longitude}, boundingBox, this.getZoom());
        if (response.isOk) {
            this.onRoutingChange(`${focusRoute}.address`, response.payload.address, true);
        }
        this.setState({focusRoute: null})
    }

    zoomIn() {
        this.map.setZoom(this.map.getZoom() + 1);
    }

    zoomOut() {
        this.map.setZoom(this.map.getZoom() - 1);
    }

    locate() {
        this.locateBtn._onClick();
        this.measureBtn._disableMeasure();
    }

    measure() {
        /*this.setState({
            routingActive: false,
        });*/
        this.measureBtn._toggleMeasure();
    }

    async routing() {
        this.measureBtn._disableMeasure();

        await this.setState({
            routingActive: !this.state.routingActive,
        });
    }

    async closeRouting() {
        await this.setState({
            routingActive: false,
            routingResultActive: false
        });
        if (!window.RNIS_SETTINGS.planning_trip_from_to) {
            await this.setState({
                routing: _.cloneDeep(this.defaultRouting)
            });
        }
    }

    fitBounds(bounds) {
        this.map.fitBounds(bounds);
    }

    panTo(coordinates) {
        this.map.panTo(coordinates);
    }

    flyTo(coordinates, zoom) {
        this.map.flyTo(coordinates, zoom);
    }

    renderUserGeoObjects(userGeoObjects) {
        this.objectsLayer.clearLayers();
        _.each(userGeoObjects, (object) => {
            const geometry = {
                type: 'Feature',
                geometry: object.geometry,
            };
            let layer = new L.GeoJSON(geometry);
            layer.bindTooltip(object.title, {sticky: true});
            this.objectsLayer.addLayer(layer);
        });
    }

    renderMapSearchObjects(mapSearchObjects) {
        this.mapSearchObjectsLayer.clearLayers();

        _.each(mapSearchObjects, (object) => {
            const geometry = {
                type: 'Feature',
                geometry: object.geometry,
            };
            let layer = new L.GeoJSON(geometry);

            if (object.hint) {
                layer.bindTooltip(object.hint, {sticky: true});
            }
            if (object.popup) {
                layer.bindPopup(object.popup);
            }

            this.mapSearchObjectsLayer.addLayer(layer);
        });
    }

    renderRoutingRequestMarkers() {
        if (!this.state.routingActive) {
            return;
        }

        const routing = this.state.routing;

        return _.concat([
            (routing.from.latitude && routing.from.longitude) ? (
                <RoutingMarker
                    key="from"
                    map={this}
                    leafletMap={this.map}
                    latitude={routing.from.latitude}
                    longitude={routing.from.longitude}
                    type="from"
                    onDrag={this.onMarkerDragEnd.bind(this, 'from')}
                    options={{
                        //interactive: this.state.focusRoute !== 'from',
                    }}
                />
            ) : null,
            (routing.to.latitude && routing.to.longitude) ? (
                <RoutingMarker
                    key="to"
                    map={this}
                    leafletMap={this.map}
                    latitude={routing.to.latitude}
                    longitude={routing.to.longitude}
                    type="to"
                    onDrag={this.onMarkerDragEnd.bind(this, 'to')}
                    options={{
                        //interactive: this.state.focusRoute !== 'to',
                    }}
                />
            ) : null,
        ], _.map(routing.transit, (transit, index) => {
            if (transit.latitude && transit.longitude) {
                return (
                    <RoutingMarker
                        key={`transit:${index}`}
                        map={this}
                        leafletMap={this.map}
                        latitude={transit.latitude}
                        longitude={transit.longitude}
                        onDrag={this.onMarkerDragEnd.bind(this, `transit.${index}`)}
                        options={{
                            //interactive: this.state.focusRoute !== `transit.${index}`,
                        }}
                    />
                );
            }

            return null;
        }));
    }

    renderRoutingResult() {
        if (!this.state.routingActive || !this.state.routingResultActive) {
            return;
        }
        const result = this.state.routingResult;
        const item = _.get(result.items, this.state.activeRoutingResultItem);
        if (!item) {
            return;
        }

        return _.map(item.segments, (segment, index) => {
            const isActive = this.state.activeSegment === index;

            const from = _.first(segment.geometry.coordinates);

            switch (segment.mode) {
                case 'walk':
                    const tooltip = `<i class="p-result__icon p-result__icon_wh24 p-result__icon_walk"></i> ${segment.time}мин, ${formatDistance(segment.distance)}`;
                    return [
                        <MapGeojson
                            key={index}
                            map={this}
                            leafletMap={this.map}
                            geometry={segment.geometry}
                            color="#000000"
                            weight={isActive ? 8 : 2}
                            onClick={this.setActiveSegment.bind(this, index)}
                        />,
                        <RoutingMarker
                            key={`${index}:from`}
                            map={this}
                            leafletMap={this.map}
                            latitude={from[1]}
                            longitude={from[0]}
                            tooltip={isActive ? `<b>${tooltip}</b>` : tooltip}
                            onClick={this.setActiveSegment.bind(this, index)}
                            permanentTooltip={true}
                            zIndex={isActive ? 100 : 10}
                            options={{
                                interactive: true,
                                opacity: 0,
                            }}
                        />,
                    ];
                case 'bus':
                    const tooltipBus = `<i class="p-result__icon p-result__icon_wh24 p-result__icon_bus"></i> ${segment.route_number}, ${segment.time}мин`;
                    return _.concat([
                        <MapGeojson
                            key={index}
                            map={this}
                            leafletMap={this.map}
                            geometry={segment.geometry}
                            color="#FF0000"
                            weight={isActive ? 8 : 2}
                            onClick={this.setActiveSegment.bind(this, index)}
                        />,
                        <RoutingMarker
                            key={`${index}:from`}
                            map={this}
                            leafletMap={this.map}
                            latitude={from[1]}
                            longitude={from[0]}
                            tooltip={isActive ? `<b>${tooltipBus}</b>` : tooltipBus}
                            onClick={this.setActiveSegment.bind(this, index)}
                            permanentTooltip={true}
                            zIndex={isActive ? 100 : 10}
                            options={{
                                interactive: true,
                                opacity: 0,
                            }}
                        />,
                    ], _.map(segment.stop_points, (stopPoint, stopPointIndex) => {
                        if (!isActive && stopPointIndex !== 0) {
                            return;
                        }
                        return (
                            <StopPointMarker
                                key={`${index}:${stopPointIndex}`}
                                map={this}
                                leafletMap={this.map}
                                latitude={stopPoint.latitude}
                                longitude={stopPoint.longitude}
                                color="red"
                                item={{
                                    title: (stopPointIndex === 0) ? `${stopPoint.name}, "${segment.route_number}", ${segment.time}мин` : stopPoint.name,
                                }}
                                withoutPopup={true}
                                zIndex={9999}
                            />
                        );
                    }));
            }
        });
    }

    async invalidateSize() {
        await setTimeout(() => {
            this.map.invalidateSize();
        }, 500);
    }

    async startRouting() {
        this.invalidateSize();
        /*await this.setState({
            routingResult: payload,
            routingResultActive: true,
        });
        console.log('qwe', payload);
        return;*/

        const routing = this.state.routing;
        if (!routing.from.latitude || !routing.from.longitude) {
            alerts.alert('Не задан начальный пункт');
            return;
        }
        if (!routing.to.latitude || !routing.to.longitude) {
            alerts.alert('Не задан конечный пункт');
            return;
        }

        this.setState({
            loading: true,
        });

        const response = await this.props.routing({
            from: routing.from,
            to: routing.to,
            transit: routing.transit,
            datetime: moment(moment(routing.date).format(formats.DATE) + ' ' + routing.time, formats.DATETIME_SHORT).format(formats.DATETIME_API),
            max_time: this.timeToInt(routing.max_time),
            max_transfers: routing.max_transfers,
            modes: this.getRoutingModes(),
            walk_reluctance: this.getWalkReluctance(routing.walk_reluctance),
            is_wheelchair: routing.is_wheelchair,
            version: 2,
        });

        this.setState({
            loading: false,
        });

        if (response.isOk) {
            await this.setState({
                routingResult: this.prepareRouting(response.payload),
                routingResultActive: true,
            });
        } else {
            response.showErrors();
        }
    }

    prepareRouting(payload) {
        let transitIndex = 0;

        payload.items = _.map(payload.items, (item) => {
            item.segments = _.map(item.segments, (segment) => {
                segment.stop_points = _.map(segment.stop_points || [], (stopPoint) => {
                    if (stopPoint.name === 'Конечный пункт') {
                        const transit = _.get(this.state.routing.transit, transitIndex);
                        if (transit) {
                            stopPoint.name = transit.address || '-';
                            transitIndex++;
                        }
                    }

                    return stopPoint;
                });

                return segment;
            });

            return item;
        });

        return payload;
    }

    getWalkReluctance(walkReluctance) {
        switch (walkReluctance) {
            case 0:
                return 16;
            case 1:
                return 4;
            case 2:
                return 2;
            case 3:
                return 1;
        }
    }

    timeToInt(time) {
        const timeObject = moment(time, formats.TIME);
        return timeObject.hours() * 60 + timeObject.minutes();
    }

    getRoutingModes() {
        let modes = [];

        modes.push('WALK');
        if (this.state.routing.mode_bus) {
            modes.push('TRANSIT');
        }

        return modes;
    }

    async setActiveSegment(index) {
        await this.setState({
            activeSegment: (this.state.activeSegment !== index) ? index : null,
        });

        const segment = _.get(this.state.routingResult, `items.${this.state.activeRoutingResultItem}.segments.${this.state.activeSegment}`);
        if (segment) {
            this.map.fitBounds((new L.geoJSON(segment.geometry)).getBounds(), {
                padding: new L.point(20, 20),
            });
        }
    }

    onSuggestClick(object) {
        this.flyTo({
            lat: object.latitude,
            lng: object.longitude,
        }, 16);

        this.setState({
            activeSearchMarker: object,
        });
    }

    renderActiveSearch() {
        if (!this.state.activeSearchMarker) {
            return;
        }

        return (
            <HistoryPointMarker
                map={this}
                leafletMap={this.map}
                latitude={this.state.activeSearchMarker.latitude}
                longitude={this.state.activeSearchMarker.longitude}
            />
        );
    }

    setSearchStopPoints(stopPoints) {
        this.setState({
            searchStopPoints: stopPoints,
        });
    }

    renderSearchStopPoints() {
        return _.map(this.state.searchStopPoints, (stopPoint) => (
            <StopPointMarker
                key={stopPoint.uuid}
                map={this}
                leafletMap={this.map}
                latitude={stopPoint.latitude}
                longitude={stopPoint.longitude}
                item={stopPoint}
                color="red"
                permanentTooltip={stopPoint.permanent}
                onScheduleClick={this.onScheduleClick.bind(this, stopPoint)}
                onFromHereClick={this.onFromHereClick.bind(this, stopPoint)}
                onToHereClick={this.onToHereClick.bind(this, stopPoint)}
                zIndex={9999}
            />
        ));
    }

    onScheduleClick(stopPoint) {
        this.props.onStopPointScheduleClick(stopPoint);
    }

    onFromHereClick(stopPoint) {
        this.props.onStopPointFromHereClick(stopPoint);
    }

    onToHereClick(stopPoint) {
        this.props.onStopPointToHereClick(stopPoint);
    }

    onSearchStopPointClick(stopPoint) {
        this.props.onStopPointClick(stopPoint);
    }
}






// WEBPACK FOOTER //
// ./src/components/ui/map.js